import React from "react";
import { Box, VStack, Heading, Text, UnorderedList, ListItem, Link, Divider } from "@chakra-ui/react";

const britishColumbiaIncomeSources = [
  "Canadian Pension Plan (CPP)",
  "Employment Insurance (EI)",
  "Baby Bonus/ Canada Child Tax Benefit (CCTB)",
  "Employment Insurance Maternity Leave (EI)",
  "Universal Child Benefit (UCB)",
  "Old Age Security",
  "Workplace Safety and Insurance (WSIB)",
  "Private Pensions (Blue Cross, Sun Life, etc.)",
];

export default function BritishColumbiaEligibilityPage() {
  return (
    <Box width="100%" bg="gray.50" pt={{ base: 28, md: 32 }} pb={{ base: 12, md: 16 }} px={{ base: 4, md: 8 }}>
      <VStack maxW="980px" mx="auto" spacing={8} align="stretch">
        <Box
          border="1px solid"
          borderColor="blue.100"
          borderRadius="2xl"
          px={{ base: 5, md: 8 }}
          py={{ base: 8, md: 10 }}
          bgGradient="linear(to-r, blue.50, white)"
          boxShadow="sm"
        >
          <VStack spacing={4} textAlign="center" maxW="900px" mx="auto">
            <Heading size="xl">Do You Qualify For A Swift Credit Loan in British Columbia?</Heading>
            <Text color="gray.700" lineHeight="1.8">
              If you’re living in British Columbia, Swift Credit accepts a wide variety of income sources from the federal (Canada) and provincial (British Columbia) governments, as well as private sources, such as insurance or pension companies.
            </Text>
          </VStack>
        </Box>

        <Box border="1px solid" borderColor="gray.200" borderRadius="2xl" px={{ base: 5, md: 8 }} py={{ base: 6, md: 8 }} bg="white" boxShadow="sm">
          <VStack spacing={5} align="stretch">
            <Heading size="md">British Columbia Government Income Sources That Qualify:</Heading>

            <Box border="1px solid" borderColor="gray.200" borderRadius="xl" bg="gray.50" px={{ base: 4, md: 5 }} py={{ base: 4, md: 5 }}>
              <UnorderedList spacing={3} pl={5} color="gray.800">
                {britishColumbiaIncomeSources.map((source) => (
                  <ListItem key={source}>{source}</ListItem>
                ))}
              </UnorderedList>
            </Box>

            <Divider borderColor="gray.200" />

            <Text color="gray.700" lineHeight="1.8">
              Please note that this list is not comprehensive. We accept most types of fixed government income that are direct deposited on a monthly basis. If you are unsure whether your British Columbia government subsidy or fixed monthly income qualifies you to receive a cash loan from us, please call us at{" "}
              <Link href="tel:+17802422478" color="blue.700" fontWeight="700" textDecoration="underline" textUnderlineOffset="3px">
                +17802422478
              </Link>
            </Text>
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
}
